class CartDiscount extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('.discount-form');
    this.input = this.form.querySelector('input');
    this.error = this.form.querySelector('p.error');
    this.submitButton = this.form.querySelector('.submit-discount');
    this.removeButtons = this.querySelectorAll('.remove-discount');

    this.enteredDiscountCode = '';
    this.discountCodes = this.dataset.discountCodes ? this.dataset.discountCodes.split(',').filter(Boolean) : [];
    this.violationMessages = this.dataset.violations ? JSON.parse(this.dataset.violations) : {};

    this.handleApply = this.handleApply.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleInputKeydown = this.handleInputKeydown.bind(this);
  }

  connectedCallback() {
    this.submitButton.addEventListener('click', this.handleApply);
    this.input.addEventListener('keydown', this.handleInputKeydown);
    this.removeButtons.forEach((btn) => btn.addEventListener('click', this.handleRemove));
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener('click', this.handleApply);
    this.input.removeEventListener('keydown', this.handleInputKeydown);
    this.removeButtons.forEach((btn) => btn.removeEventListener('click', this.handleRemove));
  }

  handleInputKeydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handleApply(e);
    }
  }

  async handleApply(e) {
    e.preventDefault();

    const discountCode = this.input.value.trim();
    this.hideError();

    if (!discountCode) return;

    if (this.discountCodes.some((code) => code.toLowerCase() === discountCode.toLowerCase())) {
      this.showError(this.error.dataset.alreadyApplied);
      return;
    }

    this.enteredDiscountCode = discountCode;
    const newCodes = [...this.discountCodes, discountCode];

    this.submitButton.disabled = true;

    try {
      await fetch(`/checkout?discount=${newCodes.join(',')}`, {
        method: 'GET',
      }).catch((error) => {
        console.warn('Discount request to /checkout was not readable (likely cross-origin redirect):', error);
      });
      await this.reloadCart();
    } finally {
      this.submitButton.disabled = false;
    }
  }

  async handleRemove(e) {
    const discountCode = e.currentTarget.dataset.code;
    const remainCodes = this.discountCodes.filter((c) => c !== discountCode);

    await fetch(`/checkout?discount=${remainCodes.join(',')}`, {
      method: 'GET',
    }).catch((error) => {
      console.warn('Discount request to /checkout was not readable (likely cross-origin redirect):', error);
    });

    this.refreshCart();
  }

  async reloadCart() {
    try {
      const response = await fetch('/cart.js');
      const data = await response.json();
      const applied = this.extractAppliedDiscounts(data);

      if (!applied.some((code) => code.toLowerCase() === this.enteredDiscountCode.toLowerCase())) {
        const violationMessage = this.violationMessages[this.enteredDiscountCode.toLowerCase()];
        this.showError(violationMessage || this.error.dataset.notFound);
      } else {
        this.refreshCart();
      }
    } catch (error) {
      console.error('Failed to reload cart:', error);
      this.showError(this.error.dataset.generic);
    }
  }

  extractAppliedDiscounts(cart) {
    const applied = [];

    cart.cart_level_discount_applications.forEach((d) => {
      if (d.type === 'discount_code') applied.push(d.title);
    });

    cart.items.forEach((item) => {
      item.line_level_discount_allocations.forEach((d) => {
        if (d.discount_application.type === 'discount_code') applied.push(d.discount_application.title);
      });
    });

    return [...new Set(applied)];
  }

  refreshCart() {
    const cartItems = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      cartItems.onCartUpdate();
    } else {
      window.location.reload();
    }
  }

  showError(message) {
    if (!message) return;
    this.error.textContent = message;
    this.error.hidden = false;
  }

  hideError() {
    this.error.hidden = true;
    this.error.textContent = '';
  }
}

customElements.define('cart-discount', CartDiscount);
